import {Component, OnInit} from '@angular/core';
import {DataService} from '../../../../Services/data.service';
import {Router} from '@angular/router';
import {HttpErrorResponse} from '@angular/common/http';
import {NotificationService} from '../../../../Services/notification.service';
import {DateFilterService} from '../../../../Services/dateFilter.service';
import {ResponseModel} from '../../../../DataModels/response-model';
import {NgbPaginationConfig} from '@ng-bootstrap/ng-bootstrap';
import {NgbpaginationConfigService} from '../../../../Services/ngbpagination-config.service';
import {Title} from '@angular/platform-browser';
import {ListPageBase} from '../../../list-page-base';

@Component({
  selector: 'app-uom-list',
  templateUrl: './uom-list.component.html',
  styleUrls: ['./uom-list.component.css'],
  standalone: false
})
export class UomListComponent extends ListPageBase implements OnInit {
  constructor(
    private aTable: DataService,
    private aToastr: NotificationService,
    private aRoute: Router,
    private dateFilter: DateFilterService,
    private ngbConfig: NgbPaginationConfig,
    private pagerConfig: NgbpaginationConfigService,
    private titleService: Title,
  ) {
    super();
    this.ngbConfig = this.pagerConfig.getNgbPaginationConfig();
  }

  uomCount = 0;
  isLoaded = false;
  vm: any = [];

  protected fetchPage(): void {
    this.getPagedApiData();
  }

  ngOnInit() {
    this.titleService.setTitle($localize`:UOM List@@uomList:UOM List`);
    this.vm.list = [];
    this.restorePagerState();
    this.getData();
  }

  getData() {
    let paramString = '?search=' + (this.vm.searchTerm ? this.vm.searchTerm : '');
    paramString += '&fromDate=' + (this.vm.fromDate ? this.dateFilter.GetDateFormat(this.vm.fromDate) : '');
    paramString += '&toDate=' + (this.vm.toDate ? this.dateFilter.GetDateFormat(this.vm.toDate) : '');
    paramString += '&pageNumber=' + (this.page !== 0 ? this.page - 1 : 0);
    paramString += '&pageSize=' + this.pageSize;

    this.aTable.getApiListData('uom', paramString).subscribe(
      (result: ResponseModel) => {
        this.vm.list = result.Data;
        this.totalRecords = result.totalRecords;
        this.paginate(false);
        this.uomCount = result.totalRecords;
        this.isLoaded = true;
      },
      (error: HttpErrorResponse) => {
        this.aToastr.error(
          $localize`:Error loading UOM Data @@errorloadingUOMData:Error loading UOM Data`
        );
        console.log(error);
      },
      () => {}
    );
  }

  onNavigate(aID: string) {
    this.aRoute.navigate(['admin/uom-form', {id: aID}]);
  }

  getPagedApiData() {
    let paramString = '?search=' + (this.vm.searchTerm ? this.vm.searchTerm : '');
    paramString += '&fromDate=' + (this.vm.fromDate ? this.dateFilter.GetDateFormat(this.vm.fromDate) : '');
    paramString += '&toDate=' + (this.vm.toDate ? this.dateFilter.GetDateFormat(this.vm.toDate) : '');
    paramString += '&pageNumber=' + (this.page !== 0 ? this.page - 1 : 0);
    paramString += '&pageSize=' + this.pageSize;

    this.aTable.getApiListData('uom', paramString).subscribe(
      (result: ResponseModel) => {
        this.vm.list = result.Data;
        this.totalRecords = result.totalRecords;
        this.paginate(false);
        this.uomCount = result.totalRecords;
        this.isLoaded = true;
      },
      (error: HttpErrorResponse) => {
        this.aToastr.error(
          $localize`:Error loading UOM Data @@errorloadingUOMData:Error loading UOM Data`
        );
        console.log(error);
      },
      () => {}
    );
  }

  serverSearch(value) {
    this.vm.searchTerm = value.searchTerm;
    this.vm.fromDate = value.fromDate;
    this.vm.toDate = value.toDate;
    this.page = 1;
    this.getPagedApiData();
  }

  clearServerSearch(value) {
    this.vm.searchTerm = value.searchTerm;
    this.vm.fromDate = value.fromDate;
    this.vm.toDate = value.toDate;
    this.page = 1;
    this.getPagedApiData();
  }

  hideSearch() {
    this.vm.searchHidden = !this.vm.searchHidden;
  }
}
